import React, { useState, useEffect } from 'react';
import { FaPlus, FaTimes, FaMinus } from 'react-icons/fa';

const ChangeStockModalMobile = ({ openChangestockPopup, productDetails, handleClose, handleSave }) => {
    const [stock, setStock] = useState('');
    const [disable, setDisable] = useState(true);
    const [reason, setReason] = useState(false);
    const [reasonValue, setReasonValue] = useState(null);

    const [warehouse, setWarehouse] = useState([]);
    useEffect(() => {
        if (stock > 0) {
            setDisable(false);
        } else {
            setDisable(true);
        }
    }, [stock]);

    const handleIncrease = () => {
        const currentStock = stock === '' ? 0 : stock;
        setStock(parseInt(currentStock) + 1);
    };
    const handleDecrease = () => {
        if (stock > 0) {
            setStock(stock - 1);
        }
    };
    const updaterowCounts = (value) => {
        const intValue = parseInt(value) || 0;
        setStock(intValue);
    };

    useEffect(() => {
        if (openChangestockPopup) {
            api.getWarehouseProductWise(productDetails?.id).then((res) => {
                setWarehouse(res?.data);
            });
        }
    }, [openChangestockPopup, productDetails?.id]);

    const onSubmit = () => {
        const data = {
            stock_qty: stock + (warehouse?.stock_qty || 0),
            warehouse_id: 1,
            product_id: productDetails?.id,
            reason: reasonValue
        };
        handleSave(data);
    };

    if (!openChangestockPopup) return null;

    return (
			<div
				className="d-flex"
				style={{
					width: '100vw',
					height: '100dvh',
					position: 'fixed',
					left: 0,
					top: 0,
					zIndex: 20,
					background: 'rgba(0,0,0,0.07)',
					justifyContent: 'center',
					alignItems: 'end',
					paddingBottom: '90px',
					backdropFilter: 'blur(8px)',
					WebkitBackdropFilter: 'blur(8px)'
				}}
			>
				<div
					className="popup product-popup-mobile d-md-none"
					style={{
						position: 'relative',
						transform: 'none',
						top: 0,
						left: 0,
						maxWidth: '90%',
						background: '#fff',
						borderRadius: 12,
						boxShadow: 'rgb(0 0 0 / 37%) 0px 0px 20px',
						width: '100%',
						padding: '24px 16px 0 16px',
						display: 'flex',
						flexDirection: 'column'
					}}
				>
					{/* Location */}
					<div className="foundListPopup">
						<div className="row align-items-top">
							<div className="col-12">
								<div className="row">
									<div className="form-group col-md-12">
										<label className="">Location</label>
										<div className="location">
											<div className="main-location">{warehouse?.warehouse?.name}</div>
											<div className="reserved">
												<label htmlFor="">{warehouse?.stock_qty} pieces</label>
												<label htmlFor="" className="reserved-amount">
													{warehouse?.reserved_qty} reserved
												</label>
											</div>
										</div>
									</div>
								</div>
								<div className="row">
									<div className="form-group col-md-12">
										<label className="">Change Stock</label>
										<div
											className="input-group input-group-lg input-group-plus-minus"
											style={{
												display: 'flex',
												flexDirection: 'row',
												alignItems: 'center',
												width: '100%'
											}}
										>
											<button
												className="btn btn-default btn-sm"
												style={{
													borderTopLeftRadius: '8px',
													borderBottomLeftRadius: '8px',
													borderTopRightRadius: 0,
													borderBottomRightRadius: 0,
													width: 40,
													height: 40,
													display: 'flex',
													border: '1px solid #e0e0e0',
													alignItems: 'center',
													justifyContent: 'center'
												}}
												onClick={handleDecrease}
											>
												<FaMinus />
											</button>
											<input
												type="number"
												value={stock}
												className="form-cntrl text-center"
												style={{
													width: '100%',
													minWidth: 60,
													maxWidth: '70%',
													height: 40,
													fontSize: 18,
													borderRadius: 0,
													borderTop: '1px solid #e0e0e0',
													borderBottom: '1px solid #e0e0e0',
													borderLeft: 'none',
													borderRight: 'none'
												}}
												onChange={(e) => updaterowCounts(e.target.value)}
												onFocus={(event) => {
													if (stock == '0.00' || stock == '0') {
														updaterowCounts('');
													}
													event.target.select();
												}}
											/>
											<button
												className="btn btn-default btn-sm"
												style={{
													borderTopRightRadius: '8px',
													borderBottomRightRadius: '8px',
													borderTopLeftRadius: 0,
													borderBottomLeftRadius: 0,
													width: 40,
													height: 40,
													display: 'flex',
													alignItems: 'center',
													border: '1px solid #e0e0e0',
													justifyContent: 'center'
												}}
												onClick={handleIncrease}
											>
												<FaPlus />
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div
    className="btnarea"
    style={{
        position: 'sticky',
        bottom: 0,
        left: 0,
        width: '100%',
        background: '#fff',
        padding: '16px 0 12px 0',
        zIndex: 30,
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        justifyContent: 'center',
        marginTop: 'auto'
    }}
>
    <button
        disabled={disable}
        onClick={onSubmit}
        className="btn btn-main"
        style={{ marginBottom: 10 }}
    >
        {stock < 1 ? (
            'No Stock Change'
        ) : (
            <>
                Save new stock level of <span>{stock + (warehouse?.stock_qty || 0)}</span> pieces
            </>
        )}
    </button>
       <button className="btn new-btn-error" onClick={handleClose}>
							<FaTimes /> Close
						</button>
</div>
				</div>
			</div>
		);
};

export default ChangeStockModalMobile;
